import Vue from "vue";

const events = {
	pointer: {
		enter: "pointer.mouseOver",
		leave: "pointe.mouseLeave",
	},
	menu: {
		reinit: "menu.reinit",
	},
	page: {
		loaded: "pageLoaded",
	},
};

const EventBus = new Vue({
	data() {
		return events;
	},
});

export default EventBus;
